import { Organisation } from './csTypes/organisation';
import { Address } from './csTypes/address';

export class User {
  _id?: string;
  userId?: string;
  first_name?: string;
  last_name?: string;
  address?: Address;
  hometown?: string;
  about?: string;
  social_media_urls?: SocialMediaUrls;
  banner_image_mobile?: {
    medium: string;
    original: string;
    thumbnail: string;
  };
  banner_image_web?: {
    medium: string;
    original: string;
    thumbnail: string;
  };
  action_shot_image?: {
    medium: string;
    original: string;
    thumbnail: string;
  }
  verified?: boolean;
  phone?: string;
  email?: string;
  ustaId?: string;
  loginProvider?: string;
  code?: number;
  date?: Date;
  trackers?: User[];
  biographicalInformation?: BiographicalInformation =
    new BiographicalInformation();
  associated_users?: User[];
  createdAt?: string;
  updatedAt?: string;
  settings?: {
    unit: string;
  };
  role?: Role;
  organizations?: Organisation[];
  profile_image?: {
    medium: string;
    original: string;
    thumbnail: string;
  };
  jerseyNumber: string;
  partner?: string[];
  allowMatchSubscription?: boolean;
  isPublisher?: boolean;
  status: string;
  claim_status: string;
  claimedBy?: ClaimedBy;
}

interface ClaimedBy {
  _id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
}

type SocialMediaUrls = {
  facebook?: string;
  instagram?: string;
  x?: string;
  tiktok?: string;
  youtube?: string;
  linkedin?: string;
};

class Role {
  name?: string;
  value?: number;
}

class BiographicalInformation {
  sex? = 'M';
  height?: string;
  age?: number;
  playingHand? = 'R';
  doubleHandedForehand? = false;
  doubleHandedBackhand? = true;
  utr?: string;
  itf?: string;
  national?: string;
  atpwta?: string;
}


export interface TeamAdmin {
  owners: User[];
  coaches: User[];
}